import graphql from 'api/graphql';
import { fetchGigyaJWTPromise } from 'api/gigya';

import { loadQueuedFavoriteStations } from './favoriteStation-actions';
import { loadQueuedFavoriteTracks } from './favoriteTrack-actions';
import { loadQueuedFavoritePodcast } from './favoritePodcast-actions';
import { loadQueuedFavoriteClip } from './favoriteClip-actions';
import { favoriteActions } from './actions-const';
import { logger } from 'util/index';

export default function loadFavorites() {
  return async (dispatch, getState) => {
    const {
      user: { isLoggedIn },
    } = getState();

    if (!isLoggedIn) {
      return;
    }

    await dispatch(loadQueuedFavoriteStations());
    await dispatch(loadQueuedFavoriteTracks());
    await dispatch(loadQueuedFavoritePodcast());
    await dispatch(loadQueuedFavoriteClip());

    const jwtToken = await fetchGigyaJWTPromise();
    const { podcasts, stations, clips } =
      (await graphql.fetchFavorites(jwtToken).catch((err) => {
        logger.warn('[Favorites] Failed to fetch favorites from Universal API.', err);
      })) || {};

    const favorites = {
      stations: stations || [],
      podcasts: podcasts || [],
      clips: clips || [],
    };
    dispatch({ type: favoriteActions.FAVORITES_LOADED, payload: favorites });
    dispatch({ type: favoriteActions.CLEAR_FAVORITE_QUEUE });
  };
}
